import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { evaluateTransforms, evaluateFormatters } from '@elliemae/ds-shared/createDataInstance/utils';
import DSTruncatedTooltipText from '@elliemae/ds-basic/TruncatedTooltipText';

function HeaderCell(_ref) {
  var column = _ref.column,
      columnIndex = _ref.columnIndex,
      Component = _ref.component,
      classProps = _ref.classProps,
      grid = _ref.grid;
  var property = column.property,
      _column$header = column.header,
      header = _column$header === void 0 ? {} : _column$header,
      _column$props = column.props,
      props = _column$props === void 0 ? {} : _column$props;
  var evaluatedProperty = property || header && header.property;
  var label = header.label,
      _header$transforms = header.transforms,
      transforms = _header$transforms === void 0 ? [] : _header$transforms,
      _header$formatters = header.formatters,
      formatters = _header$formatters === void 0 ? [] : _header$formatters; // subscribe hook effects into header cell

  if (column.headerHookEffects) column.headerHookEffects.forEach(function (hook) {
    return hook();
  });
  var extraParameters = {
    columnIndex: columnIndex,
    property: evaluatedProperty,
    column: column,
    grid: grid
  };

  var withTooltip = function withTooltip(v) {
    return classProps && classProps.wrapText ? v : /*#__PURE__*/React.createElement(DSTruncatedTooltipText, {
      value: v
    });
  };

  var value = withTooltip(label);
  var transformedProps = evaluateTransforms(transforms, value, extraParameters);
  var formattedValue = evaluateFormatters(formatters, value, extraParameters);
  var testId = column.headerDataId || 'data-grid-header__cell';
  return /*#__PURE__*/React.createElement(Component, _extends({
    key: "".concat(evaluatedProperty, "-header"),
    "data-testid": testId,
    index: columnIndex,
    classProps: classProps
  }, props, header && header.props, transformedProps), transformedProps.children || formattedValue);
}

HeaderCell.propTypes = {
  column: PropTypes.any,
  columnIndex: PropTypes.number,
  component: PropTypes.any,
  classProps: PropTypes.any,
  grid: PropTypes.any
};

export default HeaderCell;
//# sourceMappingURL=HeaderCell.js.map
